// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import { setExportOption } from './export-option.actions';
import { resetAllCustomPdfReportItems } from '../actions';
export const exportOption = createReducer(null, on(setExportOption, (state, action) => {
    return action.exportOption;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
